import type { Carer } from '@lmc/ts-common'
import { PermissionId } from '../../../../../constants/permissionIds'
import { getEffectivePermissions } from './effectivePermissions'

export type ChipId =
  | 'safeguarding'
  | 'team'
  | 'service-user'
  | 'incident'
  | 'download-centre'
  | 'medication'

// Pure mapping: identifies which capability chips a carer earns. The
// user-facing label for each `id` is owned by the renderer (RolePermissionChips)
// so this util stays i18n-free (CM-3422).
export type Chip = {
  id: ChipId
}

const CHIP_DEFINITIONS: ReadonlyArray<{
  id: ChipId
  permission: (typeof PermissionId)[keyof typeof PermissionId]
}> = [
  {
    id: 'safeguarding',
    permission: PermissionId.MANAGE_SAFEGUARDING
  },
  {
    id: 'team',
    permission: PermissionId.VIEW_AND_RESEND_TEAM_MEMBERS
  },
  {
    id: 'service-user',
    permission: PermissionId.CREATE_AND_EDIT_SERVICE_USER_DATA
  },
  {
    id: 'incident',
    permission: PermissionId.CREATE_AND_MANAGE_INCIDENTS
  },
  {
    id: 'download-centre',
    permission: PermissionId.VIEW_REPORTS_AND_EXPORT_HOME_DATA
  }
]

export const getChipsForCarer = (carer: Carer): Chip[] => {
  const effective = getEffectivePermissions(carer)

  const chips: Chip[] = CHIP_DEFINITIONS.filter(({ permission }) =>
    effective.has(permission)
  ).map(({ id }) => ({ id }))

  if (carer.medicationPermission === true) {
    chips.push({ id: 'medication' })
  }

  return chips
}
